PJQ.views.photos = {};
PJQ.views.photos.PhotoGallery = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery'),
		subTemplates: {
			dateGroup: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery-Date-Group'),
			photo: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Gallery-Photo')
		},
		canExport: true,
		previewImageDimension: 160,
		showCreatedByLink: true
	},
	events: {
		'click .gallery-photo-image': 'viewPhoto',
		'click .gallery-photo-download': 'downloadPhoto',
		'keyup .gallery-search': 'filter',
		'click .select-photo': 'selectPhoto',
		'click .select-date-group': 'selectDateGroup',
		'click .group-by': 'selectGroupBy'
	},
	beforeFirstRender: function () {
		if (this.collection == null && this.options.project != null) {
			this.options.canExport = this.options.project.hasPermission('photoGallery.canExport');
			this.options.project.fetchGalleryPhotos(_.bind(function (photos) {
				this.collection = photos;
				this.render();
			}, this));
			return false;
		}
	},
	beforeRender: function () {
		this.groupBy = "day";
		this.renderData = {
			collection: this.collection,
			groupByDefault: this.groupBy,
			groupByOptions: ["Year", "Month", "Week", "Day"]
		}
	},
	afterRender: function () {
		if (this.collection == null) {
			new PJQ.Loader(this.$('.photo-gallery'));
		}
		else {
			this.renderPhotos();
		}

		this.filesToolbar = new PJQ.views.toolbars.FilesToolbar({
			el: this.$el,
			isPhotos: true,
			onClose: _.bind(function () {
				this.deselectAll();
			}, this)
		});

		this.startDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.gallery-filter-start-date'),
			isShowTimezone: false,
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function () {
				this.filter();
			}, this)
		});

		this.endDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.gallery-filter-end-date'),
			isShowTimezone: false,
			datepickerOptions: {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function () {
				this.filter();
			}, this)
		});
	},
	renderPhotos() {
		if (_.size(this.collection.models) === 0) {
			this.$('.photos-container .list-empty').removeClass('hidden');
		}
		else {
			let groupedPhotos;
			switch (this.groupBy) {
				case 'year':
				case 'month':
				case 'day':
					let dateFormat;
					if (this.groupBy === 'year') {
						dateFormat = 'yyyy';
					}
					else if (this.groupBy === 'month') {
						dateFormat = 'MMMM';
					}
					else if (this.groupBy === 'day') {
						dateFormat = 'ddd, MMM dd, yyyy';
					}
					groupedPhotos = _.groupBy(this.collection.models, function (model) {
						return PJQ.helpers.dateHelpers.getDateString(model.get('createdOn'), dateFormat);
					});
					break;
				case 'week':
					let startDateFormat = 'MMM dd',
						endDateFormat = 'MMM dd, yyyy';
					groupedPhotos = _.groupBy(this.collection.models, function (model) {
						let weekBounds = PJQ.helpers.dateHelpers.getWeekBounds(model.get('createdOn'));
						return PJQ.helpers.dateHelpers.getDateString(weekBounds.start, startDateFormat) + ' - ' + PJQ.helpers.dateHelpers.getDateString(weekBounds.end, endDateFormat);
					});
					break;
			}

			this.$('.photos-container').empty();
			_.each(groupedPhotos, _.bind(function (photos, date) {
				let $groupEl = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.dateGroup, {
						date: date,
						canExport: this.options.canExport
					}),
					$datePhotos = $groupEl.find('.date-group-photos');
				_.each(photos, _.bind(function (photo) {
					this.renderPhoto($datePhotos, photo);
				}, this));
				this.$('.photos-container').append($groupEl);
			}, this));
			PJQ.app.lazyLoad().update();
		}
	},
	filter: function () {
		let self = this,
			search = this.$('.gallery-search').val().toLowerCase(),
			startDateFilter = this.startDatePicker.getValue(),
			endDateFilter = this.endDatePicker.getValue();
		//Go through each of the date containers
		this.$('.gallery-date-group').each(function () {
			let $date = $(this),
				visiblePhotoCount = 0;
			//Now go through each of the photos in the date containers, keeping count of how many photos are made visible
			$date.find('.gallery-photo-container').each(function () {
				let $photo = $(this),
					cid = $(this).data('cid'),
					photo = self.collection.get(cid);
				if (_.size(search) > 0 && photo.get('name').toLowerCase().indexOf(search) === -1) {
					$photo.addClass('hidden');
				}
				else if (startDateFilter != null || endDateFilter != null) {
					let createdOn = photo.get('createdOn');
					if (startDateFilter != null && createdOn < startDateFilter) {
						$photo.addClass('hidden');
					}
					else if (endDateFilter != null && createdOn > endDateFilter) {
						$photo.addClass('hidden');
					}
					else {
						$photo.removeClass('hidden');
						visiblePhotoCount++;
					}
				}
				else {
					$photo.removeClass('hidden');
					visiblePhotoCount++;
				}
			});

			//If there weren't any photos in this date container made visible, hide the whole date container
			if (visiblePhotoCount === 0) {
				$date.addClass('hidden');
			}
			else {
				$date.removeClass('hidden');
			}
		});
	},
	selectGroupBy: function (e) {
		let $groupBy = $(e.currentTarget);
		this.$('.group-by').not($groupBy).removeClass('selected');
		$groupBy.addClass('selected');

		this.groupBy = $groupBy.data('groupBy');
		this.filesToolbar.close();
		this.renderPhotos();
	},
	renderPhoto($container, file) {
		let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.photo, {
			model: file,
			canExport: this.options.canExport,
			previewImageDimension: this.options.previewImageDimension,
			showCreatedByLink: this.options.showCreatedByLink
		});
		$container.append($fileEl);
		return $fileEl;
	},
	viewPhoto: function (e) {
		let file = this.collection.get($(e.currentTarget).closest('.gallery-photo-container').data('cid'));
		PJQ.app.view.renderPhotoViewer({
			model: file,
			canDownload: this.options.canExport
		});
	},
	downloadPhoto: function (e) {
		let file = this.collection.get($(e.currentTarget).closest('.gallery-photo-container').data('cid'));
		file.download();
	},
	selectPhoto: function (e) {
		let $photo = $(e.currentTarget).closest('.gallery-photo-container'),
			cid = $photo.data('cid'),
			photoModel = this.collection.get(cid),
			isSelected = this.filesToolbar.collection.get(cid) != null;

		if (isSelected) {
			this.filesToolbar.removeFiles(photoModel);
			$photo.removeClass('selected');
			$photo.find('.select-photo').removeClass('fa-check-square').addClass('fa-square');
		}
		else {
			this.filesToolbar.addFiles(photoModel);
			$photo.addClass('selected');
			$photo.find('.select-photo').removeClass('fa-square').addClass('fa-check-square');
		}

		let $dateGroup = $photo.closest('.gallery-date-group');
		if (_.size($dateGroup.find('.gallery-photo-container:not(.selected)')) > 0) {
			$dateGroup.find('.select-date-group').removeClass('fa-check-square').addClass('fa-square');
			$dateGroup.removeClass('selected');
		}
		else {
			$dateGroup.find('.select-date-group').removeClass('fa-square').addClass('fa-check-square');
			$dateGroup.addClass('selected');
		}
	},
	selectDateGroup: function (e) {
		let self = this,
			$dateGroup = $(e.currentTarget).closest('.gallery-date-group'),
			isSelected = $dateGroup.hasClass('selected'),
			dateGroupPhotos = [];
		$dateGroup.find('.gallery-photo-container').each(function () {
			let $photo = $(this),
				cid = $photo.data('cid');
			dateGroupPhotos.push(self.collection.get(cid));
			if (isSelected) {
				$dateGroup.find('.select-date-group, .select-photo').removeClass('fa-check-square').addClass('fa-square');
				$photo.removeClass('selected');
			}
			else {
				$dateGroup.find('.select-date-group, .select-photo').removeClass('fa-square').addClass('fa-check-square');
				$photo.addClass('selected');
			}
		});

		if (isSelected) {
			this.filesToolbar.removeFiles(dateGroupPhotos);
			$dateGroup.removeClass('selected');
		}
		else {
			this.filesToolbar.addFiles(dateGroupPhotos);
			$dateGroup.addClass('selected');
		}
	},
	deselectAll: function () {
		this.$('.gallery-photo-container.selected,.gallery-date-group.selected').removeClass('selected');
		this.$('.select-date-group, .select-photo').removeClass('fa-check-square').addClass('fa-square');
	}
});

PJQ.collections.photos = {};
PJQ.collections.photos.PhotoShare = PJQ.collections.files.FileShare.extend({
	model: PJQ.models.files.File,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'photos'
			},
			{
				endpoint: 'share',
				value: this.options.shareGuid
			}
		]);
	}
});

PJQ.modules.photos = {
	routes: [
		{
			route: 'photos/share/:id',
			name: 'sharePhotos',
			callback: function (id) {
				let photos = new PJQ.collections.photos.PhotoShare(null, {
					shareGuid: id
				});
				photos.fetch({
					success: function () {
						PJQ.app.view.renderView(PJQ.views.photos.PhotoGallery, {
							collection: photos
						});
					}
				});
			}
		},
		{
			route: 'projects/:projectId/photos',
			name: 'projectPhotos',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectphotos");
			}
		},
		{
			route: 'projects/:projectId/photos/:photoId',
			name: 'projectPhotos',
			callback: function (projectId, photoId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectphotos");
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.photos.routes);